import { useQuery } from '@tanstack/react-query';

import { facultyOptions } from '@/module/Nomen/Faculty/model/FacultyModel';

import { FilterInputProps, SelectFilter, useFilterOptions } from '@/core/components';

import { Id } from '@feature/utils';

type FacultyFilterProps = FilterInputProps & { isDisabled?: boolean; allowedIds?: Id[] };

export function FacultyFilter({ allowedIds, ...props }: FacultyFilterProps) {
  const { data, isLoading, isError } = useQuery(facultyOptions.getAll());
  const options = useFilterOptions(allowedIds ? data?.filter(faculty => allowedIds.includes(faculty.id)) : data);
  return (
    <SelectFilter
      isError={isError}
      isLoading={isLoading}
      options={options}
      {...props}
    />
  );
}
